import React from "react";

const Project = () => {
  return (
    <div id="project">
      <h1 className="text-xl font-bold text-center title">Latest Project</h1>
      <h2 className="text-4xl font-bold text-center text-white">
        What I Do for My Clients
      </h2>
      <nav class="mt-5">
        <div class="container flex items-center justify-center p-4 mx-auto text-gray-600 capitalize dark:text-gray-300">
          <a
            href="/"
            class="text-gray-800 font-bold text-sm transition-colors duration-300 transform dark:text-gray-200 border-b-2 border-blue-500 mx-1.5 sm:mx-6"
          >
            All Project
          </a>

          <a
            href="/"
            class="border-b-2 border-transparent font-bold text-sm hover:text-gray-800 transition-colors duration-300 transform dark:hover:text-gray-200 hover:border-blue-500 mx-1.5 sm:mx-6"
          >
            Full Stack Project
          </a>

          <a
            href="/"
            class="border-b-2 border-transparent font-bold text-sm hover:text-gray-800 transition-colors duration-300 transform dark:hover:text-gray-200 hover:border-blue-500 mx-1.5 sm:mx-6"
          >
            Java Script Project
          </a>

          <a
            href="/"
            class="border-b-2 border-transparent font-bold text-sm hover:text-gray-800 transition-colors duration-300 transform dark:hover:text-gray-200 hover:border-blue-500 mx-1.5 sm:mx-6"
          >
            Redux Project
          </a>
          <a
            href="/"
            class="border-b-2 border-transparent font-bold text-sm hover:text-gray-800 transition-colors duration-300 transform dark:hover:text-gray-200 hover:border-blue-500 mx-1.5 sm:mx-6"
          >
            HTML CSS Project
          </a>
        </div>
      </nav>

      <div class="flex mt-20 items-center justify-center">
        <div class="grid grid-cols-1 mx-auto gap-5 px-20 md:grid-cols-2 lg:grid-cols-3">
          <div
            class="container"
            data-aos="flip-right"
            data-aos-easing="ease-out-cubic"
            data-aos-duration="1000"
          >
            <img
              src="https://i.postimg.cc/fWHpynLP/visa.png"
              alt="Avatar"
              class="image"
            />
            <div class="overlay">
              <div class="text-md font-black text-black text-center mt-2">
               Visa Service Center
              </div>
              <div className="text-center -mt-4">
              <button
                  type="button"
                  class=" h-7 w-28 text-sm mt-5 font-semibold text-white rounded-full bg-sky-600 hover:bg-black hover:text-white"
                >
                  <a
                    href="https://david-visa-management.netlify.app/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >Live Site Link
                  
                  </a>
                </button>
              </div>
            </div>
          </div>
          <div
            class="container"
            data-aos="flip-right"
            data-aos-easing="ease-out-cubic"
            data-aos-duration="1000"
          >
            <img
              src="https://i.postimg.cc/RCwWcx8P/Parts.png"
              alt="Avatar"
              class="image"
            />
            <div class="overlay">
              <div class="text-md font-black text-black text-center mt-2">
               Parts Inventory House
              </div>
              <div className="text-center -mt-4">
                <button
                  type="button"
                  class=" h-7 w-28 text-sm mt-5 font-semibold text-white rounded-full bg-sky-600 hover:bg-black hover:text-white"
                >
                  <a
                    href="https://perts-store.firebaseapp.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >Live Site Link
                  
                  </a>
                </button>
              </div>
            </div>
          </div>
          <div
            class="container"
            data-aos="flip-right"
            data-aos-easing="ease-out-cubic"
            data-aos-duration="1000"
          >
            <img
              src="https://i.postimg.cc/KvCb81c4/gadget.png"
              alt="Avatar"
              class="image"
            />
            <div class="overlay">
              <div class="text-md font-black text-black text-center mt-2">
               Gear & Gadget Mania
              </div>
              <div className="text-center -mt-4">
              <button
                  type="button"
                  class=" h-7 w-28 text-sm mt-5 font-semibold text-white rounded-full bg-sky-600 hover:bg-black hover:text-white"
                >
                  <a
                    href="https://geargagdet.firebaseapp.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >Live Site Link
                  
                  </a>
                </button>
              </div>
            </div>
          </div>
          <div
            class="container"
            data-aos="flip-right"
            data-aos-easing="ease-out-cubic"
            data-aos-duration="1000"
          >
            <img
              src="https://i.postimg.cc/RhmKcSTB/Hospetal.png"
              alt="Avatar"
              class="image"
            />
            <div class="overlay">
              <div class="text-md font-black text-black text-center mt-2">
               Hospital Management
              </div>
              <div className="text-center -mt-4">
              <button
                  type="button"
                  class=" h-7 w-28 text-sm mt-5 font-semibold text-white rounded-full bg-sky-600 hover:bg-black hover:text-white"
                >
                  <a
                    href="https://hospetal-management.netlify.app/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >Live Site Link
                  
                  </a>
                </button>
              </div>
            </div>
          </div>
          <div
            class="container"
            data-aos="flip-right"
            data-aos-easing="ease-out-cubic"
            data-aos-duration="1000"
          >
            <img
              src="https://i.postimg.cc/RCYgnfk1/Resturent.png"
              alt="Avatar"
              class="image"
            />
            <div class="overlay">
              <div class="text-md font-black text-black text-center mt-2">
                 Restaurant Center
              </div>
              <div className="text-center -mt-4">
              <button
                  type="button"
                  class=" h-7 w-28 text-sm mt-5 font-semibold text-white rounded-full bg-sky-600 hover:bg-black hover:text-white"
                >
                  <a
                    href="https://david-resturent-service.netlify.app/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >Live Site Link
                  
                  </a>
                </button>
              </div>
            </div>
          </div>
          <div
            class="container"
            data-aos="flip-right"
            data-aos-easing="ease-out-cubic"
            data-aos-duration="1000"
          >
            <img
              src="https://i.postimg.cc/TP8wyk08/school.png"
              alt="Avatar"
              class="image"
            />
            <div class="overlay">
              <div class="text-md font-black text-black text-center mt-2">
                School Management 
              </div>
              <div className="text-center -mt-4">
              <button
                  type="button"
                  class=" h-7 w-28 text-sm mt-5 font-semibold text-white rounded-full bg-sky-600 hover:bg-black hover:text-white"
                >
                  <a
                    href="https://david-school-management.netlify.app/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >Live Site Link
                  
                  </a>
                </button>
              </div>
            </div>
          </div>
          <div
            class="container"
            data-aos="flip-right"
            data-aos-easing="ease-out-cubic"
            data-aos-duration="1000"
          >
            <img
              src="https://i.postimg.cc/6pmXTzrr/phone.png"
              alt="Avatar"
              class="image"
            />
            <div class="overlay">
              <div class="text-md font-black text-black text-center mt-2">
                Phone Mania
              </div>
              <div className="text-center -mt-4">
              <button
                  type="button"
                  class=" h-7 w-28 text-sm mt-5 font-semibold text-white rounded-full bg-sky-600 hover:bg-black hover:text-white"
                >
                  <a
                    href="https://parvez-blackview-phonemania.netlify.app/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >Live Site Link
                  
                  </a>
                </button>
              </div>
            </div>
          </div>
          <div
            class="container"
            data-aos="flip-right"
            data-aos-easing="ease-out-cubic"
            data-aos-duration="1000"
          >
            <img
              src="https://i.postimg.cc/8Pz9WMPt/income.png"
              alt="Avatar"
              class="image"
            />
            <div class="overlay">
              <div class="text-md font-black text-black text-center mt-2">
                Money Master
              </div>
              <div className="text-center -mt-4">
              <button
                  type="button"
                  class=" h-7 w-28 text-sm mt-5 font-semibold text-white rounded-full bg-sky-600 hover:bg-black hover:text-white"
                >
                  <a
                    href="https://parvez-income-expense-calculation.netlify.app/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >Live Site Link
                  
                  </a>
                </button>
              </div>
            </div>
          </div>
          <div
            class="container"
            data-aos="flip-right"
            data-aos-easing="ease-out-cubic"
            data-aos-duration="1000"
          >
            <img
              src="https://i.postimg.cc/qvXbgx9m/convenstion.png"
              alt="Avatar"
              class="image"
            />
            <div class="overlay">
              <div class="text-md font-black text-black text-center mt-2">
                 Convention Center
              </div>
              <div className="text-center -mt-4">
              <button
                  type="button"
                  class=" h-7 w-28 text-sm mt-5 font-semibold text-white rounded-full bg-sky-600 hover:bg-black hover:text-white"
                >
                  <a
                    href="https://vanos-convension-hotel.netlify.app/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >Live Site Link
                  
                  </a>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Project;
